import React, { useState, useEffect, useCallback } from "react"

import { AddToCartButton } from "../add-to-cart-button/AddToCartButton"
import { getSrc } from "gatsby-plugin-image"

import formatPrice from "@utils/formatPrice"
import shopifyClient from "@utils/shopifyClient"
import {
  toLocaliseShopifyProductData,
  toLocaliseShopifyVariantData,
} from "@utils/toLocaliseShopifyData"

import * as s from "./SummaryBar.module.scss"

export const SummaryBar = ({
  product,
  variant,
  vis,
  handleAddToCart,
  addedToCart,
  variantAvailable,
}) => {
  const localisedProductData = toLocaliseShopifyProductData(product)
  const localisedVariantData = toLocaliseShopifyVariantData(variant)
  const matchesProductVariant = (fetchedVariantId, productVariantId) => {
    return fetchedVariantId === productVariantId
  }
  const countryCode = process.env.GATSBY_LOCALE.toUpperCase()

  return (
    <div className={`${s.SummaryBar} ${vis && s.SummaryBar___vis}`}>
      <div
        className={s.SummaryBar__image}
        role="image"
        aria-label={localisedProductData.title}
        style={{
          backgroundImage: `url(${
            product.media &&
            product.media[0].image &&
            getSrc(product.media[0].image.gatsbyImageData)
          })`,
        }}
      />
      <h4>
        {localisedProductData.title}{" "}
        {localisedVariantData.title !== "Default Title" &&
          localisedVariantData.title}
      </h4>
      <h5>
        {formatPrice(
          localisedVariantData.price,
          localisedVariantData.priceCurrencyCode,
        )}
      </h5>
      <div className={s.SummaryBar__addToCartContainer}>
        {variantAvailable && (
          <>
            <AddToCartButton
              className={s.SummaryBar__addToCart}
              onClick={handleAddToCart}
              title={"Add to cart"}
              added={addedToCart}
            />
          </>
        )}
      </div>
    </div>
  )
}
